<template>
  <div>
    <Usage :line-chart-data="dailyData" :x-axis="xAxis" :grid="grid">
      <div class="title-wrap">
        <div class="today-usage-title">
          <span>Today</span>
          <span class="seconds">100S</span>
        </div>
        <div>Daily Average 35S</div>
      </div>
      <div>Dec,15,2023-Today</div>
    </Usage>
  </div>

</template>

<script>
import Usage from "@/components/Usage.vue";

export default {
  name: "DailyUsage",
  components: { Usage },
  data() {
    return {
      xAxis: {
        type: "category",
        data: [
          "0AM", "", "", "", "", "",
          "6AM", "", "", "", "", "",
          "12PM", "", "", "", "", "",
          "18PM", "", "", "", "", "",
          "24PM"
        ],
        axisTick: {
          show: function(params) {
            console.log(params)
            return true
          },
          alignWithLabel:true,
        },
        axisLabel: {

          fontSize: 9,
          interval: function(index) {
            // 控制只显示 0AM、6AM、12PM、18PM、24PM 的刻度线
            return index % 6 === 0 ? 2 : 0;
          }
        }
      },
      grid: {
        top: "10%", // 设置顶部边距为 20%
        left: 0,
        right: 10,
        bottom: 0, // 设置底部边距为 20%
        containLabel: true
      },
      dailyData: [
        100, 200, 300, 400,
        100, 200, 300, 400,
        100, 200, 300, 400,
        100, 200, 300, 400,
        100, 200, 300, 400,
        100, 200, 300, 400,
        100, 200, 300, 400]
    };
  },
  methods: {},
  mounted() {

  }
};
</script>

<style scoped lang="less">
.title-wrap {
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 12px;
  color: #333333;
  justify-content: space-between;

  .today-usage-title {
    display: flex;
    flex-direction: row;
    align-items: center;

    .seconds {
      margin-left: 10px;
      font-size: 24px;
      color: #121212;
      font-weight: bold;
    }
  }
}
</style>